import { Link } from 'react-router-dom';

export default function FeaturedProducts() {
  const products = [
    {
      id: 1,
      category: 'Solar Power',
      title: 'Jackery HomePower 3000 Solar Generator Review',
      rating: 5,
      image: 'https://static.readdy.ai/image/4cab5009fae4c10096ff71d938618757/9aee64be260098f83487d38b9678fd93.png',
      link: '/reviews/jackery-homepower-3000',
    },
    {
      id: 2,
      category: 'Refrigeration',
      title: 'SetPower RV Refrigerator 12V Portable Freezer',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/c22b266b8fcd4be6240d983dbbbac05a.jpg',
      link: '/reviews/setpower-rv-55l',
    },
    {
      id: 3,
      category: 'Hot Showers',
      title: 'Camplux Nano 3 Battery-Powered Water Heater Review',
      rating: 5,
      image: 'https://static.readdy.ai/image/4cab5009fae4c10096ff71d938618757/1a103fe6c8a6684de05441dbffc6c812.png',
      link: '/reviews/camplux-nano-3',
    },
  ];

  return (
    <section className="py-20 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">TESTED & APPROVED</p>
            <h2 className="text-5xl font-bold text-gray-900 mb-2">Latest Gear</h2>
            <h3 className="text-6xl font-serif italic text-orange-500">Reviews</h3>
          </div>
          <p className="text-gray-600 max-w-md text-right">
            Real-world testing in extreme conditions. We put every product through rigorous trials so you don't have to guess.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product) => (
            <article key={product.id} className="bg-gray-50 rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group">
              <Link to={product.link} className="block relative mb-4 rounded-xl overflow-hidden h-64 w-full cursor-pointer">
                <img
                  src={product.image}
                  alt={product.title}
                  title={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </Link>

              <span className="inline-block bg-orange-500 text-black text-xs font-bold px-4 py-1 rounded-full mb-3">
                {product.category}
              </span>

              <h4 className="text-xl font-bold text-gray-900 mb-3 leading-tight min-h-[3.5rem]">
                <a href={product.link} className="hover:text-orange-500 transition-colors">
                  {product.title}
                </a>
              </h4>

              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-lg ${i < product.rating ? 'text-orange-500' : 'text-gray-300'}`}
                  ></i>
                ))}
              </div>

              <Link
                to={product.link}
                className="inline-block w-full text-center bg-white hover:bg-orange-500 text-gray-900 hover:text-black font-semibold px-6 py-3 rounded-full border-2 border-gray-900 hover:border-orange-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Read Full Review
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
